import React from 'react';
import TableNav from './TableNav';
import Sticky from 'react-stickynode';

const Navigation = () => (
  <Sticky enabled={true} top={0}>
    <TableNav />
  </Sticky>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js